import { MtStudySession } from "server/models"
import { OrderType, StudySessionAttendanceType } from "client/utils"

export interface StudySessionProps {
    sessionId: number
}

export interface StudySessionList { [sessionId: number]: MtStudySession }
export interface StudySessionListByStudy { [studyId: number]: number[] }

export interface StudySessionAttendance {
    [sessionId: number]: {
        [teamMemberId: number]: StudySessionAttendanceType
    }
}

export interface StudySessionFilters {
    search?: string
}

export type StudySessionValidation = { [key in keyof MtStudySession]?: string }

export interface StudySessionState {
    baseRoute: string

    sessionList: StudySessionList
    sessionListByStudy: StudySessionListByStudy
    sessionIds: readonly number[]
    sessionView: MtStudySession
    sessionEdit: MtStudySession

    sessionAttendance: StudySessionAttendance

    sortColumn: keyof MtStudySession
    sortOrder: OrderType
    filters: StudySessionFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const STUDY_SESSION_BASE_ROUTE = "STUDY_SESSION_BASE_ROUTE"

export const STUDY_SESSION_LIST = "STUDY_SESSION_LIST"
export const STUDY_SESSION_LIST_BY_STUDY = "STUDY_SESSION_LIST_BY_STUDY"
export const STUDY_SESSION_IDS = "STUDY_SESSION_IDS"
export const STUDY_SESSION_VIEW = "STUDY_SESSION_VIEW"
export const STUDY_SESSION_EDIT = "STUDY_SESSION_EDIT"

export const STUDY_SESSION_ATTENDANCE = "STUDY_SESSION_ATTENDANCE"

export const STUDY_SESSION_SORT = "STUDY_SESSION_SORT"
export const STUDY_SESSION_FILTERS = "STUDY_SESSION_FILTERS"

export const STUDY_SESSION_RELOAD_LIST = "STUDY_SESSION_RELOAD_LIST"
export const STUDY_SESSION_RELOAD_VIEW = "STUDY_SESSION_RELOAD_VIEW"
export const STUDY_SESSION_RELOAD_EDIT = "STUDY_SESSION_RELOAD_EDIT"
